import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotFullKYC from './NotFullKYC';
import EnterAmount from './EnterAmount';
import { deleteWithdrawFee, generateOTP, getWithdrawFeeDetails, selectBankAccount, withdrawSuccess } from '../PaymentActions';
import WithdrawForm from './WithdrawForm';
import { getBanks } from '../../bankAccounts/accountActions';
import { openModal } from '../../modals/modalActions';
import API from '../../../APIconfig';
import './withdraw.css';

// get required state from redux state
const mapState = state => ({
    auth: state.auth,
    async: state.async,
    payment: state.payment,
    bank: state.bank,
});

const actions = {
    deleteWithdrawFee,
    generateOTP,
    getBanks,
    getWithdrawFeeDetails,
    openModal,
    selectBankAccount,
    withdrawSuccess,
};

/**
 * @class WithDrawContainter
 * @description Withdraw to bank functionality
 */
class WithDrawContainter extends Component {
    static propTypes = {
        auth: PropTypes.object.isRequired,
        async: PropTypes.object.isRequired,
        deleteWithdrawFee: PropTypes.func.isRequired,
        generateOTP: PropTypes.func.isRequired,
        getBanks: PropTypes.func.isRequired,
        getWithdrawFeeDetails: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
        selectBankAccount: PropTypes.func.isRequired,
        withdrawSuccess: PropTypes.func.isRequired,
    };

    deleteWithdrawFee = () => {
        const { deleteWithdrawFee } = this.props;

        if (typeof deleteWithdrawFee === 'function')
            deleteWithdrawFee();

        this.forceUpdate();
    }

    generateOTP = () => {
        const {
                auth: { csrfRequestIdentifier, profile: { email, mobileNo } },
                generateOTP,
                openModal,
                withdrawSuccess,
                payment: { selectedBankAccount: { accountToken }, withdrawfees: { withdrawFee, withdrawAmount }}
            } = this.props;

            const walletToken = this.props.auth && this.props.auth.migration && this.props.auth.migration.walletToken;

        const values = { "emailId": email, "mobileNumber": mobileNo };

        generateOTP(
            API.payment.generateOTPPayment,
            walletToken,
            values,
            csrfRequestIdentifier,
            () => {
                // Construct payload
                const getAmount = withdrawFee.amount + withdrawAmount.amount;

                const payload = {
                    values: values,
                    verifyData: {
                        accountToken,
                        amount: getAmount.toString(),
                    },
                    csrfRequestIdentifier: csrfRequestIdentifier,
                    forwardAction: withdrawSuccess,
                    api: {
                        generate: API.payment.generateOTPPayment,
                        verify: API.payment.verifyandwithdraw,
                    },
                    token: walletToken
                };

                // Request to open OTP modal
                openModal('OTPModal', { payload });
            }
        );
    }

    render() {
        const { auth, async, bank, getWithdrawFeeDetails, openModal, payment, selectBankAccount } = this.props;

        // Check if the user is full KYC
        const isFullKYC = auth &&
            auth.isLoggedIn &&
            auth.isLoggedIn.kycWalletState &&
            typeof auth.isLoggedIn.kycWalletState === 'string' &&
            auth.isLoggedIn.kycWalletState === 'FULL_KYC';

        // IF user is Full KYC
        if (isFullKYC) {
            return (
                <div>
                    {/* Show Enter Amount Form */}
                    {payment && (
                        !payment.withdrawfees ||
                        payment.withdrawfees && !payment.withdrawfees.withdrawFee
                    ) && <EnterAmount
                        auth={auth}
                        async={async}
                        payment={payment}
                        getWithdrawFeeDetails={getWithdrawFeeDetails}
                        done={this.fetchedFee}
                    />}

                    {/* Show Withdraw form */}
                    {payment && payment.withdrawfees && payment.withdrawfees.withdrawFee && <WithdrawForm
                        auth={auth}
                        async={async}
                        payment={payment}
                        bank={bank}
                        cancel={this.deleteWithdrawFee}
                        openModal={openModal}
                        selectAccount={selectBankAccount}
                        generateOTP={this.generateOTP}
                    />}
                </div>
            )
        }
        // IF user is not Full KYC then show NO KYC screen
        else {
            return <NotFullKYC />
        }
    }

    componentDidMount() {
        const { auth, bank, getBanks } = this.props;

        // Get bank accounts if not fetched already
        if (!bank.get) {
            getBanks(auth.csrfRequestIdentifier, auth && auth.migration && auth.migration.walletToken, true);
        }
    }
}

// Provide redux state and actions as props for component
export default connect(mapState, actions)(WithDrawContainter);
